// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"624":"public","792":"main"}[chunkId] + "." + {"624":"2ac888ba","792":"95e4121e"}[chunkId] + ".js";
};